import { createContext, useContext } from 'react'
import { configManager } from '../../Managers/Config'
import { EventManager } from '../../Managers/Event/EventManager'
import { MergeConfigAndPropsTask } from '../../Tasks/Utils/MergeConfigAndPropsTask'
import { HeaderPageStore } from './Stores/HeaderPageStore'
import { DefaultTemplate } from './Templates/DefaultTemplate'

export const HeaderPageContext = createContext()

export const createHeaderPageContext = (props = {}) => {
    // Отримуємо конфігурацію HeaderPage
    const headerPageConfig = configManager.get('HeaderPageConfig', {})
    
    // Об'єднуємо конфігурацію з пропсами через MergeConfigAndPropsTask
    const mergedProps = MergeConfigAndPropsTask({
        headerPageConfig,
        props,
    }) || props
    
    if (!mergedProps.template) {
        mergedProps.template = DefaultTemplate
    }
    
    // Створюємо тимчасовий eventManager для виконання onBeforeInit
    const tempEventManager = new EventManager()
    
    // Виконуємо всі onBeforeInit події з переданих пропсів
    if (mergedProps.eventHandlers?.onBeforeInit) {
        Object.entries(mergedProps.eventHandlers.onBeforeInit).forEach(([name, handler]) => {
            tempEventManager.on('onBeforeInit', name, handler)
        })
    }
    
    // Emit onBeforeInit події - передаємо props по ссылці для можливості змін
    tempEventManager.emit('onBeforeInit', { props: mergedProps })
    
    // Створюємо екземпляр HeaderPageStore
    const headerPageContext = new HeaderPageStore(mergedProps)
    
    // Виконуємо onAfterInit події з eventManager створеного екземпляра
    headerPageContext.getEventManager().emit('onAfterInit', { headerPageContext })
    
    return headerPageContext
}

export const useHeaderPageContext = () => useContext(HeaderPageContext)

export const HeaderPageContextProvider = ({ value, children }) => (
    <HeaderPageContext.Provider value={value}>{children}</HeaderPageContext.Provider>
)
